import utils from 'utils'
import synInvoicePage from './view/synInvoiceModal.html'
import synProgressPage from './view/synProgress.html'
import downloadRecord from './view/downloadRecord.html'
class inputPoolListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, sweetalert, initSortService, exportSettingService, getOvatAmtService, $state, $filter,selectManualSolution) {
        $scope.datePickerConfig = {
            autoclose: true, // 当选择一个日期之后是否立即关闭此日期时间选择器。
            minView: 'month', // 日期时间选择器所能够提供的最精确的时间选择视图。 选择日期后，不会再跳转去选择时分秒
            language: 'zh-CN', // 语言
            format: 'yyyy-mm-dd', // 格式
            forceParse: 0, // 是否强制解析输入框中的值
            pickTime: false,
            pickerPosition: 'bottom-right', // 出现的位置 默认值: 'bottom-right' (还支持 : 'bottom-left')
        }
        $scope.dateConfig = {
            format: 'yyyymm',
            startView: 'year',
            minView: 'year',
        }
        const types = ['invoice_source', 'ivat_inv_type', 'ovat_tax_rate', 'deduction_flag', 'specific_element', 'ivat_invoice_status', 'ivat_has_local_ticket', 'ivat_has_local_xml', 'ivat_invoice_source','ivat_source_app_id']
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
            $scope.dictData.is_red_all = [
                {
                    enumTypeCode: null,
                    enumName: '蓝票',
                    enumCode: '0',
                },
                {
                    enumTypeCode: null,
                    enumName: '红票',
                    enumCode: '1',
                },
            ]
            $scope.dictData.invoice_status = [
                {
                    enumCode: '1',
                    enumName: '正常',
                },
                {
                    enumCode: '2',
                    enumName: '已作废',
                },
                {
                    enumCode: '3',
                    enumName: '全部红冲',
                },
                {
                    enumCode: '4',
                    enumName: '部分红冲',
                },
            ]
        })
        // 选中的发票
        $scope.selectedInvoices = []
        // 导出设置
        $scope.exportCollapsed = false
        $scope.exportSetting = function exportSetting() {
            exportSettingService($scope.exportID, $scope.exportConfig)
        }
        $scope.treeConfig = {
            check: {
                //如果没有设置配置项，取默认配置
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
            },
        }
        $scope.searchData = {
            orgArr: [$scope.userInfo.org],
        }
        // const aMonth = utils.genPeriodByMonth()
        const nowDate = new Date()
        let nowYears = nowDate.getFullYear()
        let nowMoths = nowDate.getMonth()
        let _nowDate = new Date(nowYears, nowMoths, 1) //本月第一天

        const aMonth = {
            start: $filter('date')(_nowDate, 'yyyy-MM-dd'),
            end: $filter('date')(nowDate, 'yyyy-MM-dd'),
        }
        $scope.param = {
            param: {
                invoiceDateBegin: aMonth.start,
                invoiceDateEnd: aMonth.end,
                updateTimeBegin: aMonth.start,
                updateTimeEnd: aMonth.end,
                invoiceOrgIdList: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
                selectedOrgs: [$scope.userInfo.org],
                invType: '',
                electricInvoiceNum: '',
                invoiceCode: '',
                invoiceNumber: '',
                invoiceStatus: '',
                invoiceSource: '',
                saleNameCreditCode: '',
                openPeople: '',
                isRed: '',
                taxRate: '',
            },
            pageNum: 1,
            pageSize: 10,
            orderMap: {},
        }

        $scope.reset = function () {
            $scope.param.param = {
                invoiceDateBegin: aMonth.start,
                invoiceDateEnd: aMonth.end,
                updateTimeBegin: aMonth.start,
                updateTimeEnd: aMonth.end,
                invoiceOrgIdList: [$scope.userInfo.org.orgId],
                selectedOrgs: [$scope.userInfo.org],
                invType: '',
                electricInvoiceNum: '',
                invoiceCode: '',
                invoiceNumber: '',
                invoiceStatus: '',
                invoiceSource: '',
                saleNameCreditCode: '',
                openPeople: '',
                isRed: '',
                taxRate: '',
            }
            getOrgList()
        }
        $scope.orgList = []
        function getOrgList() {
            httpRequest.get_getUserOrgList().then((res) => {
                $scope.orgList = res.data.value
                $scope.selectedOrgs = $scope.orgList.filter((ele) => {
                    if (ele.orgId === $scope.userInfo.org.orgId) {
                        ele.checked = true
                    }
                })
            })
        }
        $scope.exportConfig = {
            version: 1.202,
            detailInfo: [
                {
                    label: '机构名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票种类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数电发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '货物或应税劳务服务名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '简称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '规格型号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单位',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数量',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单价',
                    selected: true,
                    defaultWord: true,
                },

                {
                    label: '金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '价税合计',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税率',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税收分类编码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方税号',
                    selected: true,
                    defaultWord: true,
                },
            ],
            mainInfo: [
                {
                    label: '机构名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票种类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数电发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '销方名称',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方税号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方地址',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方电话',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方开户银行',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '销方银行账号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方税号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '购方地址',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方电话',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方开户银行',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方银行账号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '合计金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '合计税额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '价税合计',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税率',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '备注',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票人',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数据来源',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '特定业务类型',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '主商品名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '更新时间',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '来源系统编码',
                    selected: true,
                    defaultWord: true,
                }
            ],
        }
        $scope.exportID = 401
        $scope.batchDropdownConfig = {
            btnText: '下载',
            options: [
                {
                    text: '下载票据',
                    hasPermit: 'inputInvoicePoolDownload',
                    handler() {
                        $scope.downloadModel('PDF')
                    },
                },
                {
                    text: '下载XML',
                    hasPermit: 'inputInvoicePoolDownload',
                    handler() {
                        $scope.downloadModel('XML')
                    },
                },
            ],
        }
        $scope.tableDropdownConfig = [
            {
                label: '预览',
                handler(item) {
                    let url
                    if (item.invType == '61' || item.invType == '62') {
                        url = $state.href(
                            'input.invoicePool.inputInvoicePool.tax4Detail',
                            {
                                invoiceId: item.invoiceId,
                                invType: item.invType,
                            },
                            {
                                reload: true,
                            }
                        )
                    } else {
                        url = $state.href(
                            'input.invoicePool.inputInvoicePool.tax3Detail',
                            {
                                invoiceId: item.invoiceId,
                                invType: item.invType,
                            },
                            {
                                reload: true,
                            }
                        )
                    }
                    window.open(url, '_blank')
                },
                showWhile(item, hasPermit) {
                    return hasPermit('inputInvoicePoolView')
                },
            },
            {
                label: '下载票据', //tax4_sync  税局下载
                handler(item) {
                    console.log(item)
                    let win = ''
                    //1）当本地存在发票票据文件（pdf、ofd）（本地有无票据为“有”）时，点击可下载本地源文件，通过浏览器下载文件给到用户；
                    if (item.hasLocalTicket == '1') {
                        if (item.originalFileKey) {
                            //非税局下载发票下载源文件
                            win = window.open(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/downloadOriginalFile?originalFileKey=${item.originalFileKey}&accessToken=${localStorage.id_token}`)
                        } else {
                            //单张下载发票
                            win = window.open(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/downloadTax4InvoiceSingle?invoiceId=${item.invoiceId}&invoiceFileType=1&accessToken=${localStorage.id_token}`)
                        }
                        win.onbeforeunload = function () {
                            queryList()
                        }
                    } else {
                        //2）当本地不存在发票票据文件（本地有无票据为“无”）时，点击弹出“提交下载申请”弹窗：
                        sweetalert.swal(
                            {
                                title: '提交下载申请',
                                text: '当前票据本地无票据文件，需先提交下载申请',
                                showCancelButton: true,
                                confirmButtonColor: '#0096e7',
                                confirmButtonText: '提交申请',
                                cancelButtonText: '取消',
                                closeOnConfirm: true,
                                closeOnCancel: true,
                            },
                            (isConfirm) => {
                                if (isConfirm) {
                                    let data = {
                                        invoiceFileType: '1',
                                        invoiceIdList: [item.invoiceId],
                                    }
                                    httpRequest.post_batchDownloadTax4InvoiceApply(data).then((res) => {
                                        if (res.data.success) {
                                            logger.logSuccess('提交成功，请到【下载记录】查看下载进度')
                                            queryList()
                                        } else {
                                            logger.logError(res.data.errorMsg)
                                        }
                                    })
                                }
                            }
                        )
                    }
                },
                showWhile(item, hasPermit) {
                    let flag = false
                    //票种不是“全电电子专票/全电电子普票”的 非数电发票  数据来源不是税局下载，本地存在源文件，开放  下载票据按钮
                    //①当本地存在发票文件（本地有无票据为“有”）时，开放【下载票据】按钮

                    if (item.invType != '61' && item.invType != '62' && item.invoiceSource !== 'tax4_sync' && item.hasLocalTicket == '1') {
                        flag = true
                    } else if ((item.invType == '61' || item.invType == '62') && item.invoiceSource !== 'tax4_sync') {
                        flag = true
                    } else {
                        flag = false
                    }
                    // if (item.invType != '61' && item.invType != '62' && item.hasLocalTicket == '1') {
                    //     flag = true
                    // }
                    // // ②当本地不存在发票文件（本地有无票据为“无”）时，不开放【下载票据】按钮
                    // if (item.invType != '61' && item.invType != '62' && item.hasLocalTicket != '1') {
                    //     flag = false
                    // }
                    // //票种是“全电电子专票/全电电子普票”的 数电发票：开放【下载票据】按钮
                    // if (item.invType == '61' || item.invType == '62') {
                    //     flag = true
                    // }
                    return hasPermit('inputInvoicePoolDownload') && flag
                },
            },
            {
                label: '下载XML',
                handler(item) {
                    let win = ''
                    //1）当本地存在发票xml文件（本地有无xml为“有”）时，点击可下载本地源文件，通过浏览器下载文件给到用户；
                    if (item.hasLocalXml == '1') {
                        win = window.open(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/downloadTax4InvoiceSingle?invoiceId=${item.invoiceId}&invoiceFileType=3&accessToken=${localStorage.id_token}`)
                        win.onbeforeunload = function () {
                            queryList()
                        }
                    } else {
                        // 2）当本地不存在发票xml文件（本地有无xml为“无”）时，点击弹出“提交下载申请”弹窗：
                        sweetalert.swal(
                            {
                                title: '提交下载申请',
                                text: '当前票据本地无xml文件，需先提交下载申请',
                                showCancelButton: true,
                                confirmButtonColor: '#0096e7',
                                confirmButtonText: '提交申请',
                                cancelButtonText: '取消',
                                closeOnConfirm: true,
                                closeOnCancel: true,
                            },
                            (isConfirm) => {
                                if (isConfirm) {
                                    let data = {
                                        invoiceFileType: '3',
                                        invoiceIdList: [item.invoiceId],
                                    }
                                    httpRequest.post_batchDownloadTax4InvoiceApply(data).then((res) => {
                                        if (res.data.success) {
                                            logger.logSuccess('提交成功，请到【下载记录】查看下载进度')
                                            queryList()
                                        } else {
                                            logger.logError(res.data.errorMsg)
                                        }
                                    })
                                }
                            }
                        )
                    }
                },
                showWhile(item, hasPermit) {
                    let flag = false
                    //票种是“全电电子专票/全电电子普票”的 数电发票：开放【下载xml】按钮
                    if (item.invType == '61' || item.invType == '62') {
                        flag = true
                    }
                    // 票种不是“全电电子专票/全电电子普票”的 非数电发票 不开放【下载xml】按钮
                    return hasPermit('inputInvoicePoolDownload') && flag
                },
            },
        ]
        $scope.orderMap = {}
        $scope.profileType = '310'
        $scope.customizedConfig = {
            version: 1.14,
            queryForm: [
                {
                    // 0
                    label: '机构名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '票据类型',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '数电发票号码',
                    selected: true,
                    default: true,
                },
                {
                    //5
                    label: '发票状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    default: true,
                },
                {
                    label: '数据来源',
                    selected: false,
                    default: false,
                },
                {
                    label: '销方名称/销方税号',
                    selected: false,
                    default: false,
                },
                {
                    label: '发票性质',
                    selected: false,
                    default: false,
                },
                {
                    //10
                    label: '税率',
                    selected: false,
                    default: false,
                },
                {
                    label: '更新时间',
                    selected: false,
                    default: false,
                },
                {
                    label: '抵扣标志',
                    selected: false,
                    default: false,
                },
                {
                    label: '抵扣属期',
                    selected: false,
                    default: false,
                },
                {
                    label: '特定业务类型',
                    selected: false,
                    default: false,
                },
                {
                    //15
                    label: '本地有无票据',
                    selected: false,
                    default: false,
                },
                {
                    label: '本地有无XML',
                    selected: false,
                    default: false,
                },{
                    //20
                    label: '来源系统编码',
                    selected: false,
                    default: false,
                },
            ],
            table: [
                {
                    //0
                    label: '机构名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '票据类型',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票代码',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '数电发票号码',
                    selected: true,
                    default: true,
                },
                {
                    //5
                    label: '销方名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '销方税号',
                    selected: false,
                    default: false,
                },
                {
                    label: '购方名称',
                    selected: false,
                    default: false,
                },
                {
                    label: '购方税号',
                    selected: false,
                    default: false,
                },
                {
                    label: '合计金额',
                    selected: true,
                    default: true,
                },
                {
                    //10
                    label: '合计税额',
                    selected: true,
                    default: true,
                },
                {
                    label: '价税合计',
                    selected: true,
                    default: true,
                },
                {
                    label: '税率',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    default: true,
                },
                {
                    //15
                    label: '数据来源',
                    selected: true,
                    default: true,
                },
                {
                    label: '更新时间',
                    selected: true,
                    default: true,
                },
                {
                    label: '抵扣属期',
                    selected: false,
                    default: false,
                },
                {
                    label: '抵扣标志',
                    selected: false,
                    default: false,
                },
                {
                    label: '特定业务类型',
                    selected: false,
                    default: false,
                },
                {
                    //20
                    label: '本地有无票据',
                    selected: false,
                    default: false,
                },
                {
                    label: '本地有无XML',
                    selected: false,
                    default: false,
                },{
                    label: '来源系统编码',
                    selected: false,
                    default: false,
                },
            ],
        }
        httpRequest.get_getUserCustomized($scope.profileType).then((res) => {
            if (res.data.value) {
                const { orderMap } = JSON.parse(res.data.value)
                if (orderMap) {
                    $scope.orderMap = orderMap
                }
            }
            if ($scope.orderMap.sortKey) {
                $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            }
            sessionStorage.setItem('poolParam', JSON.stringify($scope.param))
            queryList()
            getOrgList()
        })
        function queryList(msg) {
            $scope.param.param.invoiceOrgIdList = $scope.param.param.selectedOrgs.map((ele) => {
                return ele.orgId
            })
            const openLoading = window.layer.msg('正在查询，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            httpRequest
                .post_ivatFindListByPagePool($scope.param)
                .then((res) => {
                    $scope.invoiceList = res.data.value.list
                    $scope.totalItems = res.data.value.total
                    $scope.param.pageNum = res.data.value.pageNum
                    $scope.selectedInvoices = []
                })
                .finally(() => {
                    window.layer.close(openLoading)
                    if (msg) {
                        logger.logSuccess(msg)
                    }
                })
            getData()
        }
        $scope.currentOvatAmt = {}
        $scope.$watch('selectedInvoices.length', () => {
            if (!$scope.selectedInvoices.length) {
                $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal
                $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum
                $scope.totalAmt = $scope.currentOvatAmt.totalAmt
                $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt
                return
            }
            const { adValoremTotal, totalAmt, totalTaxamt } = getOvatAmtService($scope.selectedInvoices)
            $scope.adValoremTotal = adValoremTotal
            $scope.invoiceNum = $scope.selectedInvoices.length
            $scope.totalAmt = totalAmt
            $scope.totalTaxamt = totalTaxamt
        })
        function getData() {
            httpRequest.post_ivatInvoicePoolStatics($scope.param.param).then((res) => {
                $scope.adValoremTotal = res.data.value.adValoremTotal.toFixed(2) || '0.00'
                $scope.invoiceNum = res.data.value.invoiceNum || 0
                $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00'
                $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00'
                $scope.currentOvatAmt = {
                    adValoremTotal: $scope.adValoremTotal,
                    invoiceNum: $scope.invoiceNum,
                    totalAmt: $scope.totalAmt,
                    totalTaxamt: $scope.totalTaxamt,
                }
            })
        }
        // 表头排序
        $scope.orderMap = initSortService('poolParam')
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('poolParam', JSON.stringify($scope.param))
            queryList()
        }
        $scope.search = function () {
            sessionStorage.setItem('poolParam', JSON.stringify($scope.param))
            queryList()
        }
        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数
        $scope.pageChanged = function () {
            // 点击页码发起查询
            sessionStorage.setItem(
                'poolParam',
                JSON.stringify({
                    orderMap: $scope.param.orderMap,
                    pageNum: $scope.param.pageNum,
                    pageSize: $scope.param.pageSize,
                    param: sessionStorage.poolParam
                        ? JSON.parse(sessionStorage.poolParam).param
                        : {
                              invoiceDateBegin: aMonth.start,
                              invoiceDateEnd: aMonth.end,
                              updateTimeBegin: aMonth.start,
                              updateTimeEnd: aMonth.end,
                              invoiceOrgIdList: [$scope.userInfo.org.orgId],
                              invType: '',
                              electricInvoiceNum: '',
                              invoiceCode: '',
                              invoiceNumber: '',
                              invoiceStatus: '',
                              invoiceSource: '',
                              saleNameCreditCode: '',
                              openPeople: '',
                              isRed: '',
                              taxRate: '',
                          },
                })
            )
            queryList()
        }
        //同步
        $scope.synchronizationModel = async function () {

            let flag =  await selectManualSolution.getResult()
            if(!flag) return

            const modalInstance = $uibModal.open({
                template: synInvoicePage,
                controller: 'inputSynInvoiceCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-hg',
            })
            modalInstance.result.then((data) => {
                $uibModal
                    .open({
                        template: synProgressPage,
                        controller: 'inputSynProgressCtrl',
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-hg',
                        resolve: {
                            items1() {
                                return data
                            },
                        },
                    })
                    .result.then((data) => {
                        queryList()
                    })
            })
        }
        //下载
        $scope.downloadModel = async function (fileType) {
             let flag =  await selectManualSolution.getResult()
            if(!flag) return

            if ($scope.selectedInvoices.length === 0) {
                logger.logError('还未选择数据')
                return
            }
            console.log($scope.selectedInvoices)
            for (let i = 0; i < $scope.selectedInvoices.length; i++) {
                if ($scope.selectedInvoices[0].invoiceOrgId !== $scope.selectedInvoices[i].invoiceOrgId) {
                    return logger.logError('不同机构的发票不支持同时下载，请选择机构名称相同的发票进行批量下载。')
                }
                if (fileType === 'XML' && $scope.selectedInvoices[i].invType != '61' && $scope.selectedInvoices[i].invType != '62') {
                    return logger.logError('仅支持对数电电子发票下载XML，请重新选择')
                }
            }
            $uibModal.open({
                templateUrl: 'downModel.html',
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'items1',
                    ($scope, $uibModalInstance, items1) => {
                        console.log(items1)
                        let fileTypeCode
                        if (fileType === 'PDF') {
                            $scope.pdfShow = true
                            fileTypeCode = '1'
                        }
                        if (fileType === 'XML') {
                            $scope.xmlShow = true
                            fileTypeCode = '3'
                        }
                        // 非数电票据 不可下载：本地有无票据为“无”的数量 本地可下载：本地有无票据为“有”的数量 需提交下载申请：固定为“/”
                        // 数电发票 不可下载：固定为“/”  本地可下载：本地有无票据为“有”的数量  需提交下载申请：本地有无票据为“无”的数量
                        // 总计：统计求和每列数电+非数电票据的数量
                        $scope.noEleInvNoDown = 0 // 非数电票据 - 不可下载
                        $scope.noEleInvDown = 0 // 非数电票据 - 本地可下载
                        $scope.eleInvDown = 0 // 数电发票 - 本地可下载
                        $scope.eleInvDownA = 0 // 数电发票 - 需提交下载申请
                        items1.forEach((item) => {
                            if (item.invType == '61' || item.invType == '62') {
                                if (fileType === 'XML') {
                                    if (item.hasLocalXml == '1') {
                                        $scope.eleInvDown++
                                    }
                                    if (item.hasLocalXml == '0') {
                                        $scope.eleInvDownA++
                                    }
                                }
                                if (fileType === 'PDF') {
                                    if (item.hasLocalTicket == '1') {
                                        $scope.eleInvDown++
                                    }
                                    if (item.hasLocalTicket == '0') {
                                        $scope.eleInvDownA++
                                    }
                                }
                            } else {
                                if (item.hasLocalTicket == '1') {
                                    $scope.noEleInvDown++
                                }
                                if (item.hasLocalTicket == '0') {
                                    $scope.noEleInvNoDown++
                                }
                            }
                        })
                        $scope.totalDown = items1.length
                        const downloadInvoiceIds = items1.map((ele) => {
                            if (ele.hasLocalXml == '1' || ele.hasLocalTicket == '1') {
                                return ele.invoiceId
                            }
                        })
                        const invoiceIds1 = items1.map((ele) => {
                            if (fileType === 'XML') {
                                if (ele.hasLocalXml == '0') {
                                    return ele.invoiceId
                                }
                            }
                            if (fileType === 'PDF') {
                                if (ele.hasLocalTicket == '0') {
                                    return ele.invoiceId
                                }
                            }
                        })
                        let invoiceFileType = fileTypeCode
                        // 下载到本地
                        $scope.downloadLocal = function () {
                            let invoiceIds = downloadInvoiceIds.filter((item, index) => item)
                            if ($scope.eleInvDown + $scope.noEleInvDown === 0) {
                                return logger.logError('所选发票暂无本地文件，无法从本地下载，若有需提交下载申请的发票，请先提交下载申请。')
                            }
                            utils.post_downLoad(
                                {
                                    invoiceIds,
                                    invoiceFileType,
                                },
                                `${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/downloadTax4InvoiceBach?accessToken=${localStorage.getItem('id_token')}`,
                                ''
                            )
                        }
                        // 提交申请
                        $scope.submitApplication = function () {
                            let applicationInvoiceIds = invoiceIds1.filter((item, index) => item)
                            if ($scope.eleInvDownA === 0) {
                                return logger.logError('所选发票不可提交下载申请。')
                            }
                            let data = {
                                invoiceFileType: fileTypeCode,
                                invoiceIdList: applicationInvoiceIds,
                            }
                            utils.loading('正在提交下载申请...')
                            httpRequest.post_batchDownloadTax4InvoiceApply(data).then((res) => {
                                utils.loaded()
                                if (res.data.success) {
                                    logger.logSuccess('提交成功，请到【下载记录】查看下载进度')
                                } else {
                                    logger.logError(res.data.errorMsg)
                                }
                            })
                        }
                        $scope.cancel = function cancel() {
                            $uibModalInstance.dismiss()
                        }
                    },
                ],
                openedClass: 'mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return $scope.selectedInvoices
                    },
                },
            })
        }
        //下载记录
        $scope.downloadRecord = function () {
            const modalInstance = $uibModal.open({
                template: downloadRecord,
                controller: 'downloadRecordCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-hg-redFrom',
                resolve: {
                    items1() {
                        return ''
                    },
                },
            })
            modalInstance.result.then((data) => {
                queryList()
            })
        }
        // 导出
        $scope.exportInvoic = function () {
            let getdata = $.extend({}, $scope.param.param)
            const idArr = []
            $scope.selectedInvoices.forEach((item) => {
                idArr.push(item.invoiceId)
            })
            getdata.idList = idArr.join(',')
            let url = `${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/exportToExcel`
            url = `${url}?accessToken=${localStorage.getItem('id_token')}`
            for (let i = 0; i < $scope.param.orderMap.length; i++) {
                getdata.sortField = `${i}:${$scope.param.orderMap[i]}`
            }
            utils.post_downLoad(getdata, url)
        }
        $scope.goCollectRecord = function (){
            $state.go('input.invoicePool.inputInvoicePool.collectRecord',{invoiceSource: 2})
        }
    }
}

inputPoolListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', 'sweetalert', 'initSortService', 'exportSettingService', 'getOvatAmtService', '$state', '$filter','selectManualSolution']
export default inputPoolListCtrl



// WEBPACK FOOTER //
// ./src/app/input/invoicePool/inputInvoicePool/list.js